import type { LayoutItem } from "react-grid-layout";
import { DashboardWidgetType } from "./enums";
import {
  CreateUpdateDashboardContact,
  CreateUpdateDashboardNotice,
  DashboardContact,
  DashboardNotice,
  DashboardWidgetSettings,
} from "./types";

export const DASHBOARD_LAYOUT_COLS = 6;

export const DASHBOARD_LARGER_SCREEN_UPDATE_WIDTH = 1620;
export const DASHBOARD_MIDLLE_SCREEN_UPDATE_WIDTH = 1460;

export const convertDashboardContactToCreateUpdateObject = (
  contact: DashboardContact,
): CreateUpdateDashboardContact => {
  const { id, createdAt, updatedAt, institution, agent, ...data } = contact;

  return { ...data, institutionId: institution?.id, agentId: agent?.id };
};

export const convertDashboardNoticeToCreateUpdateObject = (notice: DashboardNotice): CreateUpdateDashboardNotice => {
  const { id, createdAt, updatedAt, attachments, ...data } = notice;

  return data;
};

type DashboardWidgetTypesWithoutSettings = DashboardWidgetType.NOTICES | DashboardWidgetType.PERSONAL_DATES_EXTENDED;

export const DEFAULT_WIDGET_SETTINGS_SIZE: Record<
  Exclude<DashboardWidgetType, DashboardWidgetTypesWithoutSettings>,
  { h: number; w: number }
> = {
  [DashboardWidgetType.AGENT_EDUCATIONS]: { h: 2, w: 3 },
  [DashboardWidgetType.AGENT_EXPERTISES]: { h: 2, w: 3 },
  [DashboardWidgetType.COMMISSIONS]: { h: 2, w: 3 },
  [DashboardWidgetType.CONTACTS]: { h: 2, w: 6 },
  [DashboardWidgetType.CONTRACT_STATISTICS]: { h: 2, w: 3 },
  [DashboardWidgetType.CONTRACT_STATUSES]: { h: 2, w: 3 },
  [DashboardWidgetType.EVENTS]: { h: 2, w: 3 },
  [DashboardWidgetType.GOALS]: { h: 2, w: 3 },
  [DashboardWidgetType.LOGO]: { h: 1, w: 2 },
  [DashboardWidgetType.MLM_STRUCTURE]: { h: 2, w: 3 },
  [DashboardWidgetType.PERSONAL_DATES]: { h: 2, w: 3 },
  [DashboardWidgetType.PORTFOLIO]: { h: 2, w: 3 },
  [DashboardWidgetType.STATISTICS]: { h: 1, w: 4 },
  [DashboardWidgetType.STATISTICS_EXTENDED]: { h: 1, w: 4 },
};

export const isDashboardWidgetTypeWithoutSettings = (
  type: DashboardWidgetType,
): type is DashboardWidgetTypesWithoutSettings =>
  type === DashboardWidgetType.NOTICES || type === DashboardWidgetType.PERSONAL_DATES_EXTENDED;

export const setDefaultLayoutSettings = (item: DashboardWidgetSettings): LayoutItem | undefined => {
  if (isDashboardWidgetTypeWithoutSettings(item.widgetType)) {
    return;
  }

  return {
    ...DEFAULT_WIDGET_SETTINGS_SIZE[item.widgetType],
    i: item.widgetType,
    x: 0,
    y: Infinity,
  };
};

export const percentageChange = (numerator: number, denominator: number) => {
  if (denominator === 0 && numerator === 0) {
    return 0;
  }

  if (denominator === 0) {
    return 100;
  }

  return Math.trunc((numerator / denominator) * 100) - 100;
};

export const getPercentage = (numerator: number, denominator: number) => {
  return Math.trunc((numerator / (denominator || 1)) * 100);
};

export const getRemainingPercent = (totalDays: number, remainingDays: number) => {
  if (totalDays <= 0) {
    return 0;
  }

  return Math.max(0, Math.min(100, (remainingDays / totalDays) * 100));
};
